var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 381,
    viewBox: "0 0 381 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.938 195.429C380.979 193.791 381 192.148 381 190.5C381 85.2899 295.71 0.00012207 190.5 0.00012207C85.2898 0.00012207 6.10352e-05 85.2899 6.10352e-05 190.5C6.10352e-05 192.148 0.0209867 193.791 0.062587 195.429L380.938 195.429ZM359.876 277.776L21.1238 277.776C52.7791 339.085 116.745 381 190.5 381C264.255 381 328.221 339.085 359.876 277.776Z",
    fill: "#def882"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.08b8aa023a52a0165e8a6ab51a6b22d4.svg";
export { ForwardRef as ReactComponent };